import { Component } from 'preact';
import { staticPath } from '../../utils/common';

export default class ToolTip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToolTipOpen: false
    };
  }

  componentWillUnmount() {
    this.toggleTooltipCloseEventListner(false);
  }

  toggleTooltipCloseEventListner(addListner) {
    const appEl = document.querySelector('#paytm-app');
    if (appEl) {
      if (addListner) {
        appEl.addEventListener('click', this.onToolTipClick);
      } else {
        appEl.removeEventListener('click', this.onToolTipClick);
      }
    }
  }

  stopE = ev => {
    if (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  };

  onToolTipClick = (ev, isToolTip = false) => {
    this.stopE(ev);
    this.toggleTooltipCloseEventListner(isToolTip);
    this.setState({ isToolTipOpen: isToolTip });
  };

  render({ title, desc }, { isToolTipOpen }) {
    return (
      <div className={`ptm-tt-wrap`}>
        <img
          onClick={e => {
            this.onToolTipClick(e, !isToolTipOpen);
          }}
          className={`ptm-info-icon ptm-pointer-cursor`}
          src={`${staticPath()}/assets/images/info.svg`}
          alt="i"
        />
        {isToolTipOpen && (
          <section
            onClick={e => {
              this.stopE(e);
            }}
            className={`ptm-tool-tip ptm-pos-a ptm-body-bg`}
          >
            <div className={`ptm-tt-content ptm-pos-r`}>
              <div className={`ptm-tt-title ptm-fs12 ptm-semibold ptm-body-color`}>{title}</div>
              <div className={`ptm-tt-text ptm-fs10 ptm-body-color`}>{desc}</div>
            </div>
          </section>
        )}
        <div className={`ptm-triangle ptm-body-bg`} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/tooltip/index.js